<style src="./view.scss" lang="scss"></style>
<template src="./view.html"></template>

<script>
import { getTimes, getStyle, forEachTree } from '@/common/utils'
import { SupplementaryContractDialog } from '@/components/widgets'
import PhotographicWorksDetail from '../photographic-works-detail/view.vue'
import moment from 'moment'
import { shiQuanConfig } from '@/common/app.config'
import decamelize from 'decamelize-keys-deep'

export default {
    components: { WSupplementaryContractDialog: SupplementaryContractDialog, PhotographicWorksDetail },
    data() {
        return {
            filterDrawer: false,
            filter: {},
            list: {},

            currentPage: 1,
            pageSize: 50,
            total: 0,
            loading: false,
            collapseName: '1',
            showInviteDialog: false,
            range: [],
            showTemplDialog: false,
            inviteDrawer: false,
            inviteesStatus: {
                0: '邀约状态',
                1: '邀约中',
                2: '已交稿',
                '-1': '放弃交稿'
            },
            timer: null,

            // 设置等级
            currentSetGrade: {},
            gradeDialog: false,
            classifyList: [],

            // 邀搞
            currentInvite: {},
            currentBusiness: '',
            businessList: [],
            currentProjectClassify: '',
            projectClassifyList: [],
            template: [],
            currentTemplate: {},
            // 邀约详情
            inviteDrawerInfo: {}
        };
    },
    methods: {
        init() {
            this.getWorkList()
            this.getWorkClassify()
            this.getProjectclassifyList()
            this.getProjectBusiness()
            this.getProjecttemplate()
        },
        backtop(){
            this.$refs.scrollDom.scrollTop = 0;
        },
        backTip(el){
            let str = '';
            if(el.videoUrls){
                str += '<span>视频</span>'
            }
            if(el.picUrls && el.picUrls.split(',').length > 1){
                str += '<span>多图</span>'
            }
            return str
        },
        setGrade(item) {
            this.currentSetGrade = item
            this.gradeDialog = true
        },
        async getWorkList(reload) {
            if(this.loading) return

            try {
                this.loading = true
                if(reload) {
                    this.currentPage = 1
                }

                let classify1 = new Set(), classify2 = new Set(), classify3 = new Set()

                if(this.filter.classify) {
                    this.filter.classify.forEach(item => {
                        classify1.add(item[0])
                        classify2.add(item[1])
                        classify3.add(item[2])
                    })
                }

                let filter = JSON.parse(JSON.stringify(this.filter))
                delete filter.classify

                let data = await this.api.getWorkList(Object.assign(
                    {
                        classify_1: [...classify1].join(','),
                        classify_2: [...classify2].join(','),
                        classify_3: [...classify3].join(','),
                        page: this.currentPage,
                        limit: this.pageSize,
                        createTimeStart: this.range[0] ? moment(this.range[0]).format('YYYY-MM-DD HH:mm:ss') : undefined,
                        createTimeEnd: this.range[0] ? moment(this.range[1]).format('YYYY-MM-DD 23:59:59') : undefined,
                        isJoinStore: 1
                    },
                    filter
                ))

                if(this.currentPage === 1) {
                    this.list = {}
                }

                data.data.forEach(item => {
                    const itemTime = moment(item.createTime).format('YYYY-MM-DD')

                    try {
                        item.labels = JSON.parse(item.labels)
                    } catch (error) {
                        item.labels = []
                    }
                    if(this.list[itemTime]) {
                        this.list[itemTime].push(item)
                    }else {
                        this.list[itemTime] = [item]
                    }
                })

                let { total } = data
                this.total = total
                
                this.currentPage++
            } catch (error) {
                throw new Error(error)
            } finally {
              this.loading = false
            }
        },
        closeFilterDrawer() {
            this.filterDrawer = false
        },
        clearFilter() {
            this.filter = {}
            this.range = []
            this.searchClick()
        },
        searchClick() {
            this.getWorkList(true)
            this.closeFilterDrawer()
        },
        getTimes(time) {
            return getTimes(time)
        },
        scroll(event) {
            clearTimeout(this.timer)
            this.timer = setTimeout(() => {
                const viewHeight = parseFloat(getStyle(event.target, 'height'))
                const scrollTop = event.target.scrollTop
                const scrollHeight = event.target.scrollHeight

                if((viewHeight + scrollTop) >= (scrollHeight - 600)) {
                    this.getWorkList()
                }
            }, 200)
        },
        async getWorkClassify() {
            let data = await this.api.getWorkClassify()

            data = forEachTree(data, (item) => {
                item.value = item.id
                item.label = item.classifyName
                item.children = item.subData
            }, 'subData')

            this.classifyList = data
        },
        preview({ workId }) {
            window.open(`${shiQuanConfig.url}/cont?id=${workId}`)
        },
        inviteClick(item) {
            this.currentInvite = item
            this.showInviteDialog = true
            this.currentTemplate = {}
            this.businessList.forEach(item => {
                if(item.businessName === '邀稿作品') {
                    this.currentBusiness = item.businessType
                }
            })
            this.projectClassifyList.forEach(item => {
                if(item.classifyName === '插画') {
                    this.currentProjectClassify = item.id
                }
            })
            this.template.forEach(item => {
                if(item.templateName === '邀稿投稿统一标准模板') {
                    this.currentTemplate = item
                }
            })
        },
        async getProjectclassifyList() {
            let data = await this.api.getProjectclassifyList()
            this.projectClassifyList = data.data
        },
        async getProjectBusiness() {
            let data = await this.api.getProjectBusiness()
            this.businessList = data
        },
        projectClassifyChange() {
            this.currentTemplate = {}
        },
        openTemplDialog() {
            this.showTemplDialog = true
            this.getProjecttemplate()
        },
        async getProjecttemplate() {
            const data = await this.api.getProjecttemplate({ limit: 5000, classifyId: this.currentProjectClassify })
            this.template = data.data
        },
        editTemplate() {
            if(JSON.stringify(this.currentTemplate) === '{}') {
                this.$message.error('请选择项目模板')
            }else {
                const { href } = this.$router.resolve({
                    path: '/projectManagement/projectclass/edittemplate',
                    query: { row: JSON.stringify(decamelize(this.currentTemplate)) }
                })
                window.open(href)
            }
        },
        templateRowClick(item) {
            this.currentTemplate = item
            this.showTemplDialog = false
        },
        async addInvitationProject() {
            if(!this.currentTemplate.id) {
                this.$message.error('请选择项目模板')
            }else {
                await this.api.addInvitationProject({
                    businessType: this.currentBusiness,
                    classifyId: this.currentProjectClassify,
                    templateProjectId: this.currentTemplate.id,
                    workId: this.currentInvite.workId
                })
                this.$message.success('发起邀约成功')
                this.showInviteDialog = false
                this.currentInvite.inviteesStatus = 1
            }
        },
        previewProject() {
            if(JSON.stringify(this.currentTemplate) === '{}') {
                this.$message.error('请选择项目模板')
            }else {
                const { href } = this.$router.resolve({
                    path: `/projectManagement/projectList/newproject/openproject`,
                    query: { info: JSON.stringify(decamelize(this.currentTemplate)) }
                })
                window.open(href)
            }
        },
        async getInvitationDetail(item) {
            let data = await this.api.getInvitationDetail({ workId: item.workId })

            data.renounceReason = data.renounceReason.split(',')
            this.inviteDrawerInfo = data
            this.inviteDrawer = true
        },
        setLevelSuccess(grade) {
            this.currentSetGrade.recommendLevel = grade
        }
    },
    created() {
        this.init()
    }
};
</script>